module.exports = "/_next/static/images/Claim-easymaxs-078ff4a28d06c0c58c418e63bec3dfd8.png";